module.exports = __webpack_public_path__ + "img/exportContacts.2dd3b223.svg";